import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_COMBOS = {
  'loading': false,
  'data': null,
  'list': [],
};

export const comboDetails = (state, action) => {
  return createReducer(INITIAL_STATE_COMBOS, {
    [ActionTypes.FETCHING_COMBO_DETAIL]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_COMBO_DETAIL]: (state, action) => ({
      ...state,
      'loading': false,
      'data': action.response.data,
    }),
    [ActionTypes.FETCHED_COMBO_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'data': null,
    }),
    [ActionTypes.UPDATING_COMBO]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_COMBO]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_COMBO_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};

export const accessoriesList = (state, action) => {
  return createReducer(INITIAL_STATE_COMBOS, {
    [ActionTypes.FETCHING_ACCESSORIES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ACCESSORIES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_ACCESSORIES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAN_ACCESSORIES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

export const dealersList = (state, action) => {
  return createReducer(INITIAL_STATE_COMBOS, {
    [ActionTypes.FETCHING_DEALERS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_DEALERS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_DEALERS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

export const vehiclesModelsList = (state, action) => {
  return createReducer(INITIAL_STATE_COMBOS, {
    [ActionTypes.FETCHING_VEHICLES_MODELS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLES_MODELS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_VEHICLES_MODELS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAN_VEHICLES_MODELS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

const INITIAL_STATE_KATASHIKIES_COMBO_MOD = {
  'result': false,
  'combo': '',
  'action': '',
};

export const addComboToModel = (state, action) => {
  return createReducer({INITIAL_STATE_KATASHIKIES_COMBO_MOD}, {
    [ActionTypes.ADDING_COMBO_TO_MODEL]: (state, action) => ({
      ...state,
      'result': false,
      'combo': '',
      'action': '',
    }),
    [ActionTypes.ADDED_COMBO_TO_MODEL]: (state, action) => ({
      ...state,
      'result': action.payload.data,
      'combo': action.payload.combo,
      'action': 'ADD',
    }),
    [ActionTypes.ADDED_COMBO_TO_MODEL_FAILED]: (state, action) => ({
      ...state,
      'result': false,
      'combo': '',
      'action': '',
    }),
    [ActionTypes.DELETING_COMBO_TO_MODEL]: (state, action) => ({
      ...state,
      'result': false,
      'combo': '',
      'action': '',
    }),
    [ActionTypes.DELETED_COMBO_TO_MODEL]: (state, action) => ({
      ...state,
      'result': action.payload.data,
      'combo': action.payload.combo,
      'action': 'DELETE',
    }),
    [ActionTypes.DELETED_COMBO_TO_MODEL_FAILED]: (state, action) => ({
      ...state,
      'result': false,
      'combo': '',
      'action': '',
    }),
  })(state, action);
};

